import { UserManagerSettings } from "oidc-client-ts";

const origin = window.location.origin;

export const authConfig: UserManagerSettings = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_tkqbCnwF5",
  client_id: "6gq17ii9dnjtferc9ahkbjiruq",

  redirect_uri: `${origin}/auth/callback`,
  post_logout_redirect_uri: `${origin}/login`,

  response_type: "code",
  scope: "openid email profile josenilton-agents/jobs.analyze",

  automaticSilentRenew: false,
  loadUserInfo: false,
};
